export const AutoAddressInputStyles = {
  field: 'w-full sm:w-auto',
  popper: 'z-10 w-full mt-4 px-4 sm:w-328 sm:mt-0 sm:px-0',
}
